// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-dialog-div[data-v-47661c77]{height:60vh;overflow:auto}", ""]);
// Exports
module.exports = exports;
